<div class="row justify-content-center visible" *ngIf="!isAuthenticated">
  <div class="userInfoContainer col-auto mx-3" [ngClass]="globalService.allowUserReset ? 'pointerOnHover' : ''">
    <div *ngIf="userName && !title">
      <div *ngIf="!globalService.allowUserReset">User {{userName}}</div>
      <a class="reference" *ngIf="globalService.allowUserReset" (click)="notUser()">Not {{userName}}?</a>
    </div>
    <div *ngIf="title">
      <a class="reference"  (click)="notUser()">{{title}}</a>
    </div>
  </div>
</div>
